export const API_BASE = import.meta.env.VITE_API_BASE;
export const APP_ID = import.meta.env.VITE_APP_ID;
export const BACKEND_API_HOST = import.meta.env.VITE_BACKEND_API_HOST;
